import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VueResource from 'vue-resource';
import Fragment from 'vue-fragment';
import { percentFormatter, currencyFormatter } from '@/lib/formatters';
import store from './store';
import router from './router';
import App from './App';

Vue.use(VueGtag, {
	config: { id: "G-BFM5EMEK2N" },
});
Vue.use(VueResource);
Vue.use(Fragment.Plugin);
Vue.filter('currency', currencyFormatter.format);
Vue.filter('percent', percentFormatter);

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* eslint-disable no-new */
// new Vue({
// 	el: '#app',
// 	store,
// 	router,
// 	components: { App },
// 	template: '<App/>',
// });


new Vue({
	render: (h) => h(App),
	store,
	router,
}).$mount('#app');
